import { createApp, defineAsyncComponent } from 'vue';
import mitt from 'mitt';

window.mitt = mitt;

if (typeof window !== 'undefined') {
  window.isMobile = function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
  };
}

const numflipDirective = {
  mounted(el, binding) {
    el.value = formatData(binding.value);
  },
  updated(el, binding) {
    var numberAnimation = function (el, oldValue, newValue) {
      var start = null, duration = 200
      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        el.value = formatData(Math.round(oldValue + (newValue - oldValue) * progress / duration));

        if (progress < duration) {
          window.requestAnimationFrame(step);
        } else {
          el.value = formatData(newValue);
        }
      }
      el.value = formatData(oldValue);
      window.requestAnimationFrame(step);
    };

    let value_input = parseFloat(el.value.replace(/[^\.\d]/g, ''));


    if ((parseFloat(binding.value) != value_input || parseFloat(binding.value) != parseFloat(binding.oldValue)) && binding.value !== false) {


      numberAnimation(el, binding.oldValue, binding.value)
    }
  }
};

function formatData(number) {

  let floatNum = parseFloat(number);


  if (floatNum < 1000) {
    return String(floatNum);
  }
  else {
    return floatNum.toLocaleString('ru');
  }

}

//import { Swiper, SwiperSlide } from 'swiper/vue';



//import { Navigation, Thumbs, Pagination as SwiperPagination } from 'swiper/modules';

import registry from '@/componentRegistry';
//import FileUpload from 'vue-upload-component';
//import FileUpload from 'vue-upload-component';
// import ListingCard from '@/components/listing-card';
// import ListingCardMobile from '@/components/listing-card-mobile';
// import ElementProductMobile from '@/components/page-product-mobile';
// import ElementProduct from '@/components/page-product.vue';
import { Icon } from '@iconify/vue';
//const StarRating = () => import ('vue-star-rating');
//const location = () => import ('@/components/location/template');

// import location from '@/components/location/template';

//const UserField = () => import ('@/components/user-field/template');

// import UserField from '@/components/user-field/template';


//import VueSlickCarousel from 'vue-slick-carousel';
//import PopupProduct from '@/components/popup-product';
// const Feedbacks = () => import ('@/components/feedbacks-card');
// const feedback = () => import ('@/components/feedback');

// const FeedbacksMobile = () => import ('@/components/feedbacks-card-mobile');
// const feedbackMobile = () => import ('@/components/feedback-mobile');


// import carousel from '@/components/carousel';
// import carouselMobile from '@/components/carousel-mobile';
// import catalogMobile from '@/components/catalog-mobile';
// import pagination from '@/components/pagination';
// import Vuebox from '@/components/vuebox.vue';
//const lazyloadBlock = () => import ('@/components/lazyload-block');
//const dolyami = () => import ('@/components/dolyami');
// import Vform from '@/components/v-form';
// import carouselItems from '@/components/carousel-items';
//const vuebox = () => import ('@/components/vuebox');
// const quickResponse = () => import ('@/components/quick-response');
//import '@mdi/font/css/materialdesignicons.css';
//import * as mdijs from '@mdi/js'
//import 'material-design-icons-iconfont/dist/material-design-icons.css';
// import { Carousel, Slide } from 'vue-snap';
// import StarIcon from 'vue-material-design-icons/Star.vue';
// import 'vue-snap/dist/vue-snap.css';
//const PopupProduct = () => import ('@/components/popup-product');
// import ListingCard from '@/components/listing-card';
// import ElementProduct from '@/components/page-product';
//import customTabs from '@/components/custom-tabs';
//import FeedbacksCard from '@/components/feedbacks-card.vue';
// import QuickResponse from '@/components/quick-response';
// import catalog from '@/mixins/catalog';
//import catalogListing from '@/components/catalog-listing';
//import listingSearch from '@/components/listing-search';
//const listingSearch = defineAsyncComponent(() => import('@/components/listing-search'));
//import listingSearchMobile from '@/components/listing-search-mobile';
//import listingBase from '@/mixins/listing-base';
//import feedback from '@/components/feedback';
//import slider from '@/components/slider';
import * as yandexEcommerce from '@/utils/yandexEcommerce';
import intersect from '@/direct/intersect.js';
// const SmartFilter = defineAsyncComponent(() => import('@/components/smart-filter'));
// const CatalogMenu = defineAsyncComponent(() => import('@/components/catalog-menu'));

//import 'vue3-range-slider/dist/vue3-range-slider.css';


// const SliderComponent = {
//   props: {
//     min: { type: Number, required: true },
//     max: { type: Number, required: true },
//     modelValue: { type: Array, default: () => [0, 100] },
//     tooltip: { type: Boolean, default: true }
//   },
//   template: '<div></div>',
//   mounted() {
//     const sliderEl = this.$el;
//     window.noUiSlider.create(sliderEl, {
//       start: [this.modelValue[0], this.modelValue[1]],
//       connect: true,
//       step: 1,
//       range: {
//         'min': this.min,
//         'max': this.max
//       },
//       tooltips: this.tooltip ? {
//         to: function (value) { return Math.round(value); }
//       } : false
//     });

//     sliderEl.noUiSlider.on('change', (values) => {
//       const newValues = values.map(v => parseFloat(v));
//       this.$emit('update:modelValue', newValues);
//     });

//     this.sliderInstance = sliderEl.noUiSlider;
//   },
//   updated() {
//     if (this.sliderInstance && !this.arraysEqual(this.sliderInstance.get(), this.modelValue.map(v => v.toString()))) {
//       this.sliderInstance.set(this.modelValue);
//     }
//   },
//   beforeUnmount() {
//     if (this.sliderInstance) {
//       this.sliderInstance.destroy();
//     }
//   },
//   methods: {
//     arraysEqual(a, b) {
//       return a.length === b.length && a.every((val, index) => val === parseFloat(b[index]));
//     }
//   }
// };


window.bus = window.mitt();

// история поисковых запросов для инлайн-шаблонов vue:search_complete
import { pushHistory, getHistory, removeHistory, clearHistory } from '@/utils/searchHistory';
window.searchHistory = { push: pushHistory, get: getHistory, remove: removeHistory, clear: clearHistory };

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/grid';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

//window.mixins = { catalog: catalog };

// export default new vuetify({
//   icons: {
//     iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
//   },
// });
//console.log(window.mixins);
//window.Vue = undefined;

if (typeof window.global_vue !== 'undefined') {

  window.global_vue.forEach(function (item, index, array) {

    console.log('Processing Vue item:', index, item.el);

    // item["vuetify"] = null;

    const components = {}

    if (item.components) {
      item.components.forEach(name => {
        if (registry[name]) {
          components[name] = defineAsyncComponent(registry[name]);

           //console.log(components[name]);
        }
      })
    }

    const appOptions = {
      ...item,
      components,
      mixins: [],
    };


    //console.log('Item mixins before:', item.mixins);

    // if (item.mixins && Array.isArray(item.mixins)) {
    //   item.mixins.forEach(mixinName => {
    //     if (window.mixins[mixinName]) {
    //       appOptions.mixins.push(window.mixins[mixinName]);
    //     }
    //   });
    // }

    //console.log('Item mixins after:', item.mixins);

    console.log('App created for', item.el);
    let app = createApp(appOptions);
    app.config.globalProperties.$ecommerce = yandexEcommerce;

    app.config.globalProperties.$isMobile = function () {
      if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
    };
    app.config.compilerOptions = { isCustomElement: (tag) => tag.startsWith('swiper-') };
    app.directive('numflip', numflipDirective);
    app.directive('intersect', intersect);
    app.component('Icon', Icon);
    // app.component('Swiper', Swiper);
    // app.component('SwiperSlide', SwiperSlide);

    // // ⬇️ Глобальные модули Swiper
    // app.config.globalProperties.$swiperModules = {
    //   Navigation,
    //   SwiperPagination,
    //   Thumbs
    // };

    // for (let key in item["components"]) {
    //   app.component(key, item["components"][key]);
    // }
    // if (item["mixins"]) {
    //   item["mixins"] = item["mixins"].map(element => {
    //     if (typeof element == "string") {
    //       return window.mixins[element];
    //     }
    //     return element;
    //   });
    // }

   

   

    app.config.errorHandler = (err, instance, info) => {
      console.error('⚠️ Vue Error:', err);
      console.log('🔍 Component instance:', instance);
      console.log('🧾 Info:', info);
    }


    if (item.el) {
      app.mount(item.el);
    } else {
      console.error('Не указан "el" для компонента');
    }

  });

  //window.Vue = createApp();
  window.global_vue = [];

  window.initVueComponent = function(selector) {
    const configs = window.global_vue || [];
    const item = configs.find(c => c.el === selector);
    if (!item) return;

    const components = {};
    if (item.components) {
      item.components.forEach(name => {
        if (registry[name]) {
          components[name] = defineAsyncComponent(registry[name]);
        }
      });
    }

    const appOptions = { ...item, components, mixins: [] };
    const app = createApp(appOptions);
    app.config.globalProperties.$ecommerce = yandexEcommerce;
    app.config.globalProperties.$isMobile = function () {
      if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
    };
    app.config.compilerOptions = { isCustomElement: (tag) => tag.startsWith('swiper-') };
    app.directive('numflip', numflipDirective);
    app.directive('intersect', intersect);
    app.component('Icon', Icon);
    app.config.errorHandler = (err, instance, info) => {
      console.error('Vue Error:', err);
    };
    if (item.el) app.mount(item.el);
  };

}
